import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo from '../components/Seo';
import { getAuthor } from '../lib/api';

function AutorDetail() {
  const { slug } = useParams();
  const [author, setAuthor] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    getAuthor(slug)
      .then((data) => setAuthor(data.author))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="page page--narrow">
        <h1>Autor no encontrado</h1>
        <Link to="/autores">Volver a autores</Link>
      </div>
    );
  }

  if (!author) return null;

  return (
    <article className="page page--narrow">
      <Seo title={author.name} description={author.bio} image={author.photo_url} />
      {author.photo_url && <img src={author.photo_url} alt={author.name} style={{ maxWidth: 200, borderRadius: '50%' }} />}
      <h1>{author.name}</h1>
      {author.country && <p className="content-card__category">{author.country}</p>}
      {author.bio && <p>{author.bio}</p>}

      {author.books?.length > 0 && (
        <>
          <h3>Libros</h3>
          <div className="card-grid">
            {author.books.map((book) => (
              <Link key={book.id} to={`/libros/${book.slug}`} className="content-card">
                {book.cover_url && <img src={book.cover_url} alt={book.title} />}
                <div className="content-card__body">
                  <h3 className="content-card__title">{book.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </article>
  );
}

export default AutorDetail;
